import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { TinyMceModule } from 'angular-tinymce';
// import { tinymceDefaultSettings } from 'angular-tinymce';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';
import { OomphService } from '../../services/oomph/oomph.service';

// import the ChartModule for the Chart component
import { ChartModule } from '@syncfusion/ej2-angular-charts';
import { CategoryService, LegendService, TooltipService, ColumnSeriesService } from '@syncfusion/ej2-angular-charts';
import { DataLabelService, LineSeriesService, StackingColumnSeriesService } from '@syncfusion/ej2-angular-charts';

import { OomphComponent } from './oomph.component';
import { OomHeaderComponent } from './oom-header/oom-header.component';
import { OomDashboardComponent } from './oom-dashboard/oom-dashboard.component';
import { OomPaymentsComponent } from './oom-payments/oom-payments.component';

import { SharedModule } from '../../shared.module';

const OomphRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'oomph/dashboard',
    component: OomDashboardComponent,
  }, {
    path: 'oomph/payments',
    component: OomPaymentsComponent,
  }, 
]);

@NgModule({
  exports: [
  ],
  imports: [
    NgbDropdownModule.forRoot(),
    OomphRouting, 
    SharedModule,
    DataTableModule,
    // TinyMceModule.forRoot(tinymceDefaultSettings()),
    NgxMaskModule.forRoot(),
    // Ng4FilesModule
    // syncfusion
    ChartModule
  ],
  declarations: [
    OomphComponent,
    // TinymceComponent,
    OomDashboardComponent,
    OomPaymentsComponent,
    OomHeaderComponent
  ],
  providers: [
    OomphService,
    NgbModal,
    NgbActiveModal,
    // syncfusion
    CategoryService, LegendService, TooltipService, DataLabelService, LineSeriesService, StackingColumnSeriesService, ColumnSeriesService
  ],
  // add components here for dynamic loading
  entryComponents: [ 
  ]
})

export class OomphModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oomph.module.ts